import { Repository } from "./adapters/repository";
import { ActivityReport } from "./adapters/activityReport";

import * as allocateResources from "./useCases/allocateResources";
import * as checkAllocationWarnings from "./useCases/checkAllocationWarnings";
import * as editAllocation from "./useCases/editAllocation";
import * as removeAllocation from "./useCases/removeAllocation";
import * as sendActivityReport from "./useCases/sendActivityReport";

enum UseCases {
  allocateResources = "allocateResources",
  checkAllocationWarnings = "checkAllocationWarnings",
  editAllocation = "editAllocation",
  removeAllocation = "removeAllocation",
  sendActivityReport = "sendActivityReport",
}

interface Core {
  [UseCases.allocateResources]: allocateResources.Interactor;
  [UseCases.checkAllocationWarnings]: checkAllocationWarnings.Interactor;
  [UseCases.editAllocation]: editAllocation.Interactor;
  [UseCases.removeAllocation]: removeAllocation.Interactor;
  [UseCases.sendActivityReport]: sendActivityReport.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
  activityReport: ActivityReport;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.allocateResources]: allocateResources.createInteractor(
      dependencies.repository,
    ),
    [UseCases.checkAllocationWarnings]:
      checkAllocationWarnings.createInteractor(dependencies.repository),
    [UseCases.editAllocation]: editAllocation.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeAllocation]: removeAllocation.createInteractor(
      dependencies.repository,
    ),
    [UseCases.sendActivityReport]: sendActivityReport.createInteractor(
      dependencies.activityReport,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
